import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/common/Header/Header";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
const Layout = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const excludeRoutes = ["/document/sign/approved", "/document/sign/declined"];
  const location = useLocation();
  return (
    <div>
      {isAuthenticated && !excludeRoutes.includes(location.pathname) && (
        <Header />
      )}
      <Outlet />
    </div>
  );
};

export default Layout;
